import { insertBefore, removeChildren } from '../html.js';
import { LoadingIndicator } from '../loading.jsx';
import xhr from '../xhr.js';
import { AudioEmbedPlaceholder, AudioEmbedPlayer } from './audio.jsx';
import { ImageEmbed } from './image.jsx';
import { VideoEmbedNicoNico, VideoEmbedPlaceholder, VideoEmbedPlayer, VideoEmbedYouTube } from './video.jsx';

const baseUrl = 'https://uiharu.' + location.host; // stinky

export function handleEmbeds(targets) {
    if(!Array.isArray(targets))
        targets = Array.from(targets);

    const filtered = new Map;
    for(const target of targets) {
        if(!(target instanceof HTMLElement)
            || !('dataset' in target)
            || !('mszEmbedUrl' in target.dataset))
            continue;

        const cleanUrl = target.dataset.mszEmbedUrl.replace(/ /, '%20');
        if(cleanUrl.indexOf('https://') !== 0
            && cleanUrl.indexOf('http://') !== 0
            && cleanUrl.indexOf('//') !== 0) {
            target.textContent = target.dataset.mszEmbedUrl;
            continue;
        }

        removeChildren(target);
        target.appendChild((new LoadingIndicator({ inline: true })).element);

        if(filtered.has(cleanUrl))
            filtered.get(cleanUrl).push(target);
        else
            filtered.set(cleanUrl, [target]);
    }

    const replaceWithUrl = function(targets, url) {
        for(const target of targets) {
            insertBefore(target, <a class="link" target="_blank" rel="noopener noreferrer" href={url}>{url}</a>);
            target.remove();
        }
    };

    filtered.forEach(function(targets, url) {
        xhr.post(`${baseUrl}/metadata`, { type: 'json' }, url).catch(ex => {
            replaceWithUrl(targets, url);
            console.error(ex);
        }).then(result => {
            try {
                const metadata = result.body;
                if(metadata.error)
                    throw new Error('An error occurred during metadata lookup.', { cause: metadata.error });
                if(metadata.title === undefined)
                    throw new Error('Requested media is not available.');

                let createEmbed = () => null;
                if(metadata.type === 'youtube:video')
                    createEmbed = target => { target.replaceWith(new VideoEmbedPlaceholder(metadata, VideoEmbedYouTube, { type: 'youtube' }).element); };
                else if(metadata.type === 'niconico:video')
                    createEmbed = target => { target.replaceWith(new VideoEmbedPlaceholder(metadata, VideoEmbedNicoNico, { type: 'nicovideo' }).element); };
                else if(metadata.is_video)
                    createEmbed = target => { target.replaceWith(new VideoEmbedPlaceholder(metadata, VideoEmbedPlayer, { autosize: true }).element); };
                else if(metadata.is_audio)
                    createEmbed = target => { target.replaceWith(new AudioEmbedPlaceholder(metadata, AudioEmbedPlayer).element); };
                else if(metadata.is_image)
                    createEmbed = target => { target.replaceWith(new ImageEmbed(metadata, target).element); };

                for(const target of targets)
                    createEmbed(target);
            } catch(ex) {
                console.error(ex);
                replaceWithUrl(targets, url);
            }
        });
    });
};
